import { styled, css, useTheme } from '@vebox/etui-system';
import { mediaMax } from '../utilities/responsive.js';
import { createElement, Fragment } from 'react';
import '../useDebounce/useDebounce.js';
import '../useWindowSize/useWindowSize.js';
import useResponsive from '../useResponsive/useResponsive.js';
import { Div } from '@vebox/etui-system-elements';

const MainNative = props => /*#__PURE__*/createElement("main", {
  className: props.className
}, props.children);
const Main = styled(MainNative)`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  align-items: stretch;
  overflow: hidden;
`;

const Section = props => /*#__PURE__*/createElement("section", {
  className: props.className
}, props.children);
const ContentSection = styled(Section)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1 1 auto;
  width: 100%;
  overflow-y: hidden;
`;

const ListWrapperDiv = styled(Div)`
  display: flex;
  width: 40%;
  max-width: 480px;
  overflow-y: hidden;
  position: relative;
  align-self: stretch;
  flex-direction: column;

  ${({
  theme
}) => css`
    border-right: 1px solid ${theme.palette.divider};
    background-color: ${theme.palette.common.white};
  `};

  ${({
  theme
}) => mediaMax(theme).sm`
    width: 100%;
    max-width: none;
    border-right: 0;
  `};
`;

const ContentWrapperDiv = styled(Div)`
  display: flex;
  overflow-y: hidden;
  position: relative;
  align-self: stretch;
  flex: 1 1 auto;
  width: 60%;

  ${({
  isListItemActive
}) => !isListItemActive && css`
      justify-content: center;
      align-items: center;
    `};
`;

const ContentScrollDiv = styled(Div)`
  width: 100%;
  overflow-y: auto;
  position: relative;
`;

function ListView({
  header,
  headerSmall,
  list,
  children,
  activeItemKey = null,
  onNoneSelectedRender,
  emptyPlaceholder
}) {
  const theme = useTheme();
  const {
    screenIsAtMost
  } = useResponsive({
    xs: parseInt(theme.breakpoints[0], 10),
    sm: parseInt(theme.breakpoints[1], 10),
    md: parseInt(theme.breakpoints[2], 10),
    lg: parseInt(theme.breakpoints[3], 10)
  });
  const isSmView = screenIsAtMost('sm');
  const getIsListEmpty = () => {
    if (list && list.props && list.props.dataSource) {
      const data = list.props.dataSource;
      return data.length === 0;
    }
    return true;
  };
  const isAnyListItemActive = activeItemKey !== null;
  return /*#__PURE__*/createElement(Main, null, (!isSmView || !isAnyListItemActive) && header, isSmView && isAnyListItemActive && headerSmall, /*#__PURE__*/createElement(ContentSection, null, !getIsListEmpty() && (!isAnyListItemActive || !isSmView) && /*#__PURE__*/createElement(ListWrapperDiv, null, list), isSmView ? /*#__PURE__*/createElement(Fragment, null, isAnyListItemActive && !getIsListEmpty() && /*#__PURE__*/createElement(ContentWrapperDiv, {
    isListItemActive: isAnyListItemActive
  }, /*#__PURE__*/createElement(ContentScrollDiv, null, children)), getIsListEmpty() && /*#__PURE__*/createElement(ContentWrapperDiv, {
    isListItemActive: isAnyListItemActive
  }, emptyPlaceholder)) : /*#__PURE__*/createElement(Fragment, null, !isAnyListItemActive ? /*#__PURE__*/createElement(ContentWrapperDiv, {
    isListItemActive: isAnyListItemActive
  }, getIsListEmpty() && emptyPlaceholder, !getIsListEmpty() && onNoneSelectedRender && onNoneSelectedRender()) : /*#__PURE__*/createElement(ContentWrapperDiv, {
    isListItemActive: isAnyListItemActive
  }, /*#__PURE__*/createElement(ContentScrollDiv, null, children)))));
}

export default ListView;
